/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const co=!1;export{co as isServer};
//# sourceMappingURL=is-server.js.map
